import { SURVEY_APP_URL } from "@/data/links";
import { Link } from "react-router-dom";
import { HOME } from "@/constants/testIds";
import { LOGO_URL } from "@/constants/brand";

export default function Footer() {
  return (
    <footer
      data-testid={HOME.footer}
      className="bg-cocoa-900 text-parchment-200 pt-20 pb-10 grain"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 border-b border-parchment-100/15 pb-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-14 h-14 rounded-full overflow-hidden border border-parchment-100/40 bg-parchment-100 flex-shrink-0">
                <img src={LOGO_URL} alt="Parish seal" className="w-full h-full object-cover" />
              </div>
              <div>
                <div className="font-serif text-parchment-100 text-lg">
                  Saint Francis of Assisi Parish
                </div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-gold mt-1 font-sans">
                  Mabuhay · Diocese of Marbel
                </div>
              </div>
            </div>
            <p className="font-sans font-light text-parchment-200/80 leading-relaxed max-w-md">
              A parish community called to live the Gospel with simplicity,
              fraternity, service, and missionary hope. <span className="italic">Pax et bonum.</span>
            </p>
          </div>

          <FooterCol
            title="Visit"
            items={[
              ["About", "#about"],
              ["Mass Schedule", "#schedule"],
              ["Ministries", "#ministries"],
              ["Sacraments", "#sacraments"],
              ["Church Construction", "#construction"],
            ]}
          />

          <FooterCol
            title="Services"
            items={[
              ["Baptism", "#sacraments"],
              ["Confirmation", "#sacraments"],
              ["Matrimony", "#sacraments"],
              ["Anointing", "#sacraments"],
              ["Contact Office", "#contact"],
            ]}
          />

          <div className="lg:col-span-2">
            <h4 className="font-serif text-parchment-100 text-base mb-4">Office</h4>
            <p className="text-sm text-parchment-200/80 font-sans font-light leading-relaxed">
              Brgy. Mabuhay,<br />
              General Santos City<br />
              Diocese of Marbel
            </p>
            <Link
              to="/admin"
              className="inline-block mt-5 text-[10px] uppercase tracking-[0.28em] text-gold hover:text-parchment-100 transition-colors"
            >
              Parish Admin →
            </Link>
            <a
              href={`${SURVEY_APP_URL}/login`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-staff-login"
              className="block mt-2 text-[10px] uppercase tracking-[0.28em] text-parchment-200/70 hover:text-gold transition-colors"
            >
              Staff Login →
            </a>
          </div>
        </div>

        <div className="mt-8 flex flex-col md:flex-row gap-3 justify-between items-center text-[11px] uppercase tracking-[0.22em] text-parchment-200/60 font-sans">
          <div>
            © {new Date().getFullYear()} Saint Francis of Assisi Parish — Mabuhay
          </div>
          <div className="flex items-center gap-3">
            <span>Pax et Bonum</span>
            <span className="text-gold">✦</span>
            <span>mabuhayparish.org</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div className="lg:col-span-2">
      <h4 className="font-serif text-parchment-100 text-base mb-4">{title}</h4>
      <ul className="space-y-2.5 font-sans text-sm text-parchment-200/80 font-light">
        {items.map(([label, href]) => (
          <li key={label}>
            <a href={href} className="hover:text-gold transition-colors">
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
